import { IconStatus } from '@components/icons/status';
import { FilterConfigField } from '@components/table';
import { FilterData } from '@components/table/filters';

import { useStore } from 'models/Provider';

const statusFieldToExternalQuery = (filter: FilterData) => {
  switch (filter.comparer) {
    case 'is':
      return { status__term: filter.value };
    case 'any_of':
      const value = Array.isArray(filter.value) ? filter.value.join('__') : filter.value;
      return { status__terms: value };
    case 'not_is':
    case 'none_of':
      return { status__exclude: filter.value };
    default:
      return {};
  }
};

export const useStatusFilter = (): FilterConfigField => {
  const { t } = useStore();

  return {
    id: 'status',
    label: t('applicants.status.title'),
    icon: <IconStatus />,
    type: 'single_select',
    values: [
      { value: 'active', label: t('applicants.status.active') },
      { value: 'hired', label: t('applicants.status.hired') },
      { value: 'rejected', label: t('applicants.status.rejected') },
      { value: 'retracted', label: t('applicants.status.retracted') },
    ],
    toExternalQuery: statusFieldToExternalQuery,
  };
};
